/** Reversible color-preview overlay. Default production palette is `current`. */

export const PALETTE_STORAGE_KEY = 'agent_palette'

export const PALETTE_OPTIONS = [
  { id: 'current', label: 'Current' },
  { id: 'lake', label: 'Lake Hour' },
  { id: 'chili', label: 'Chili & Shade' },
]

const PALETTE_IDS = new Set(PALETTE_OPTIONS.map((option) => option.id))

export function isPaletteId(value) {
  return typeof value === 'string' && PALETTE_IDS.has(value)
}

export function resolvePalette() {
  return 'current'
}

export function applyPalette(palette, {
  root = typeof document !== 'undefined' ? document.documentElement : null,
  storage = typeof localStorage !== 'undefined' ? localStorage : null,
} = {}) {
  const next = isPaletteId(palette) ? palette : 'current'
  if (root) {
    if (next === 'current') {
      root.removeAttribute('data-palette')
    } else {
      root.setAttribute('data-palette', next)
    }
  }
  try {
    storage?.setItem?.(PALETTE_STORAGE_KEY, next)
  } catch {
    // ignore storage errors
  }
  return next
}

export function applyResolvedPalette(options) {
  return applyPalette(resolvePalette(options), options)
}

export function shouldShowPaletteExplorer() {
  return false
}
